'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _HR = require('UIComponents/elements/HR');

var _HR2 = _interopRequireDefault(_HR);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalculatorDivider = (0, _styledComponents2.default)(_HR2.default).withConfig({
  displayName: 'CalculatorDivider'
})(['width:28px;margin:36px 0;color:', ';border-color:', ';background-color:', ';'], _colors.BATTLESHIP, _colors.BATTLESHIP, _colors.BATTLESHIP);

exports.default = CalculatorDivider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/CalculatorDivider.js
// module id = 337
// module chunks = 3 4